import axios from 'axios'
import store from '@/store'
import { attachNetworkQualityInterceptor } from '@/utils/networkQualityMonitor'

const operationClient = axios.create({})

attachNetworkQualityInterceptor(operationClient)

operationClient.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`
    config.headers.lang = store.getters['getLang']
    config.url = `${process.env.VUE_APP_PROTOCOL}://${store.getters['auth/getTenantHost']}/operation/api/v1${config.url}`
    return config;
})

export default operationClient